import { useEffect, useMemo, useRef, useState } from 'react';
import InputC from 'Common/Inputs/index.tsx';
import { FormC } from 'Common/Form/index.tsx';
import { Row, Col, Spinner } from 'reactstrap';
import { Collapse } from 'reactstrap';
import Nodatacomponent from 'components/Nodatacomponent';
import { SVG } from 'components/HeadlessCMS/svg';
import { connect } from 'react-redux';
import {
  changeCollectionsdata,
  changeComponentsdata,
  changeSinglesdata,
  GetMedia,
} from 'actions/headlesscmsActions';
import ManageButton from './ManageButton';

import { ButtonC } from 'Common/Buttons';
import TableC from 'Common/Table/index.tsx';
import { DropZoneModel } from '../Models/Dropzonmodel';
import Axios from 'functions/Axios';
import { API_URI, CMS_API_URL, CMS_PUBLIC_API_URL } from 'Constant';
import { toast } from 'react-toastify';
import SpinnerLoader from 'components/SpinnerLoader';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import SideOverlay from './DetailOverlay';
import { RelationSelect } from 'components/HeadlessCMS/functions';
import { CarousalC } from 'Common/Carousel/index.tsx';
import { saveAs } from 'file-saver';
import DraftLogic from './DraftLogic';
import { handleValidation } from "./functions"
import ConfigButton from "./ConfigViewButton"
import FiltersCM from "./Filters"

export const StatusValues = {
  0: 'Unpublish',
  1: 'Published',
  2: 'Draft',
  3: 'Modified',
};

export const StatusClasses = {
  0: {
    div: 'unpublished-div',
    text: '#753cb7',
    bacground: '#e2c9ff',
  },
  1: {
    div: 'published-div',
    text: '#519b4a',
    bacground: '#f2fbf1',
  },
  3: {
    div: 'modified-div',
    text: '#753cb7',
    bacground: '#e2c9ff',
  },
  2: {
    div: 'modified-div',
    text: '#753cb7',
    bacground: '#fff',
  },
};
const formatDate = (epochTime) => {
  const date = new Date(epochTime * 1000); // Convert seconds to milliseconds
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
const isJsonString = (str) => {
  if (str === 'undefined' || str === undefined || str === null) return false;
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};
const formatData = (item, index) => {
  return {
    src: item.thumbnailPath || item.filePath,
    altText: item.fileOriginalName,
    caption: item.caption || '',
    filePath: item.filePath,
    id: item.mediaFileId, // Assuming the key should be a unique identifier
  };
};


const getStatus = (ispublish, isdraft) => {
  var status = 0;

  if (ispublish === true && isdraft === false) {
    status = 1;
  }
  if (ispublish === true && isdraft === true) {
    status = 3;
  }
  if (ispublish === false && isdraft === true) {
    status = 2;
  }
  if (ispublish === false && isdraft === false) {
    status = 0;
  }
  return status;
};
function completeAnswerJson(draftJson, answerJson) {
  for (const key in draftJson) {
    if (!(key in answerJson)) {
      answerJson[key] = "";
    }
  }
  return answerJson;
}
const ContentManager = (props) => {
  const Components = props.cms.components;
  const [searchParams, setSearchParams] = useSearchParams();

  const [Collapsediv, setCollapsediv] = useState({});
  const [dropdown, setdropdown] = useState([]);
  const [SelectedType, setSelectedType] = useState(null);
  const [OverlaySelectedType, setOverlaySelectedType] = useState(null);
  const [CollectionType, setCollectionType] = useState(null);
  const [Creationdata, setCreationdata] = useState({
    createdon: '',
    createdby: '',
    updatedby: '',
    updatedon: '',
  });
  const [istable, setistable] = useState(false);
  const [loading, setloading] = useState(false);
  const [loadingdata, setloadingdata] = useState(false);
  const [publishloading, setpublishloading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [Tabledata, setTabledata] = useState([]);
  const [editid, seteditid] = useState(null);
  const [isPublish, setisPublish] = useState(false);
  const [DataStatus, stDataStatus] = useState(0);
  const [Pagination, setPagination] = useState();
  const [currentpage, setcurrentpage] = useState(parseInt(searchParams.get("page")) || 1);
  const [pagesize, setpagesize] = useState(20);
  const [Filterdata, setFilterdata] = useState({
    key: "All",
    sortOrder: 2,
    orderType: 1,
    status: "All"
  })
  const [firstloading, setfirstloading] = useState(false);

  const { type, pluralid, submitionId } = useParams();
  const [Inputvalues, setInputvalues] = useState({});
  const [DraftJson, setDraftJson] = useState({});
  const [AnswerJson, setAnswerJson] = useState({});
  const [PredefinedValues, setPredefinedValues] = useState({});
  const [RelationInputvalues, setRelationInputvalues] = useState({});

  const [DraftRelationInputvalues, setDraftRelationInputvalues] = useState({});
  const [PublishRelationInputvalues, setPublishRelationInputvalues] = useState({});

  const [UpdateRelationInputvalues, setUpdateRelationInputvalues] = useState({});
  const [OldRelationInputvalues, setOldRelationInputvalues] = useState({});




  //  ==========================================================================
  //  =============================== Draft Logic ==============================
  //  ==========================================================================

  const [SelectTab, setSelectTab] = useState(0);
  const isDraft = SelectTab === 0 || SelectTab === 2;
  const isEdited =
    JSON.stringify(DraftJson) === JSON.stringify(Inputvalues) &&
    JSON.stringify(DraftRelationInputvalues) === JSON.stringify(RelationInputvalues);
  const isModified = DataStatus !== 3;
  useEffect(() => {
    if (SelectTab === 1) {
      const updatedAnswer = completeAnswerJson(DraftJson, AnswerJson);
      setInputvalues(updatedAnswer);
      setRelationInputvalues(PublishRelationInputvalues);
      setUpdateRelationInputvalues(PublishRelationInputvalues);
      setOldRelationInputvalues(PublishRelationInputvalues);
    } else {
      setInputvalues(DraftJson);
      setRelationInputvalues(DraftRelationInputvalues);
      setUpdateRelationInputvalues(DraftRelationInputvalues);
      setOldRelationInputvalues(DraftRelationInputvalues);
    }
  }, [AnswerJson, DraftJson, SelectTab, DraftRelationInputvalues, PublishRelationInputvalues]);

  //   setcurrentpage(page);
  //   setpagesize(pageSize);
  // }, []);

  const FetchProducts = async () => {
    const response = await Axios.get(`${API_URI}/api/clients/products/getallactivesku`)
    const Tags = await Axios.get(`${API_URI}/api/clients/products/listofproductstags`)
    const Category = await Axios.get(`${API_URI}/api/clients/products/getlistofcategories`)
    const Ranges = await Axios.get(`${API_URI}/api/clients/products/getproductsrange`)
    setPredefinedValues({
      "Products": response.data.data.map(item => ({ label: item, value: item })),
      "tags": Tags.data.data.map(item => ({ label: item.tagName, value: item.productstagID })),
      "category": Category.data.data.map(item => ({ label: item.categoryName, value: item.product_category })),
      "ranges": Ranges.data.data.map(item => ({ label: item.rangeName, value: item.rangeID })),
    })
  }





  useEffect(() => {
    FetchProducts()
  }, [])









  //  ==========================================================================
  //  =============================== Draft Logic ==============================
  //  ==========================================================================
  var UpdateRelationInputvalue = {};

  const handlecollapse = (id) => {
    setCollapsediv({
      ...Collapsediv,
      [id]: !Collapsediv[id],
    });
  };

  const [errorMessage, seterrorMessage] = useState({});
  const resetState = () => {
    setcurrentpage(1);
    setpagesize(20);
    setCollapsediv({});
    setdropdown([]);
    setSelectedType(null);
    setOverlaySelectedType(null);
    setCollectionType(null);
    setCreationdata({
      createdon: '',
      createdby: '',
      updatedby: '',
      updatedon: '',
    });
    setistable(false);
    setloading(false);
    setloadingdata(false);
    setpublishloading(false);
    setDrawerOpen(false);
    setTabledata([]);
    seteditid(null);
    setisPublish(false);
    seterrorMessage({});
    setRelationInputvalues({});
    setUpdateRelationInputvalues({});
    UpdateRelationInputvalue = {};
    setFilterdata({
      key: "All",
      sortOrder: 2,
      orderType: 1,
      status: "All"
    })
  };

  const AdditionalValidation = (item, name, value) => {
    if (item.Min && item.Min !== null) {
      if (value.length < item.Min) {
        seterrorMessage({
          ...errorMessage,
          [name]: `length must be greater than ${item.Min} Characters`,
        });

        return true;
      } else {
        seterrorMessage({
          ...errorMessage,
          [name]: ``,
        });
      }
    }
    if (item.Max && item.Max !== null) {
      if (value.length > item.Max) {
        seterrorMessage({
          ...errorMessage,
          [name]: `Length must not be greater than ${item.Max} characters.`,
        });

        return false;
      } else {
        seterrorMessage({
          ...errorMessage,
          [name]: ``,
        });
      }
    }

    return true;
  };

  //   ===================================== For Navigation ===============================================
  const navigate = useNavigate();
  const prevCollectionKeyRef = useRef(null);
  const isFilterMounted = useRef(false);
  useEffect(() => {
    setcurrentpage(parseInt(searchParams.get("page")) || 1);
    setpagesize(parseInt(searchParams.get("pageSize")) || 20);
  }, [searchParams]);
  useEffect(() => {
    if (type === 'collection') {
      var collection = props.cms.collections.find((item) => item.plural === pluralid);
      if (collection) {
        handlecollection(collection, submitionId, Filterdata);
      }
      return;
    }
    if (type === 'single') {
      var singles = props.cms.singles.find((item) => item.plural === pluralid);
      if (singles) {
        handledata(singles);
      }
      return;
    }
  }, [currentpage]);

  useEffect(() => {
    const collectionKey = `${type}__${pluralid}`;
    const collectionChanged = prevCollectionKeyRef.current !== null && prevCollectionKeyRef.current !== collectionKey;
    prevCollectionKeyRef.current = collectionKey;

    if (collectionChanged) {
      resetState();
      setSearchParams((prev) => {
        const next = Object.fromEntries(prev);
        delete next.page;
        return next;
      });
    }

    if (pluralid) {
      setfirstloading(true);
      setTimeout(() => {
        setfirstloading(false);
      }, 2000);
    }

    if (type === 'collection') {
      var collection = props.cms.collections.find((item) => item.plural === pluralid);
      if (collection) {
        handlecollection(collection, submitionId, Filterdata, collectionChanged ? 1 : undefined, collectionChanged ? 20 : undefined);
      }
      return;
    }
    if (type === 'single') {
      var singles = props.cms.singles.find((item) => item.plural === pluralid);
      if (singles) {
        handledata(singles);
      }
      return;
    }
  }, [type, pluralid, props.cms.collections, submitionId, props.cms.singles, pagesize]);


  useEffect(() => {
    if (!isFilterMounted.current) {
      isFilterMounted.current = true;
      return;
    }
    setcurrentpage(1);
    if (type === 'collection') {
      var collection = props.cms.collections.find((item) => item.plural === pluralid);
      if (collection) {
        handlecollection(collection, submitionId, Filterdata, 1, pagesize);
      }
      return;
    }
    if (type === 'single') {
      var singles = props.cms.singles.find((item) => item.plural === pluralid);
      if (singles) {
        handledata(singles);
      }
      return;
    }
  }, [Filterdata]);



  //   ===================================== For Navigation ===============================================

  const { id: domainId } = useParams();
  useEffect(() => {
    setpublishloading(false);
    setCollectionType(null);
    setSelectedType(null);
    setCollapsediv({});
  }, [domainId]);
  const handlecollection = async (data, submitionId, Filterdata, page, size) => {
    try {
      setloadingdata(true);
      const activePage = page !== undefined ? page : currentpage;
      const activeSize = size !== undefined ? size : pagesize;
      const params = {
        page: activePage - 1,
        size: activeSize,
      };

      // add filter only if text exists
      Object.entries(Filterdata || {}).forEach(([key, value]) => {
        if (
          value !== undefined &&
          value !== null &&
          value !== ''
        ) {
          params[key] = value;
        }
      });

      if (params.status === 'All') {
        delete params.status;
      }

      const response2 = await Axios.get(
        `${CMS_API_URL}/submission/getContent/${data.plural}/${domainId}`,
        { params }
      );
      setPagination(response2.data.data.metaData?.pagination);
      var response = {
        data: {
          data: response2.data.data.submissions,
        },
      };

      var datas = [];
      response.data.data &&
        response.data.data.map((item) => {
          const value = getStatus(item.status, item.draftStatus);
          datas.push({
            ...item,
            datastatus: StatusValues[value],
            answerJson: value === 2 ? JSON.parse(item.draftJson) : JSON.parse(item.answerJson),
          });
        });
      setTabledata(datas);
      var items = [];
      setloadingdata(false);
      setdropdown(items);
      setCollectionType(data);
      setSelectedType(null);
      setistable(true);
      if (submitionId) {
        var res = await Axios.get(`${CMS_API_URL}/submission/get/${submitionId}/${domainId}`);
        var product = {
          ...res.data.data,
          answerJson: JSON.parse(res.data.data.answerJson),
        };
        // setTimeout(() => {
        EditSubmitions(product, data);
        // }, 200);
      }
    } catch (error) {
      console.error(error);
      setloadingdata(false);
    }
  };
  const handleCollectiondata = (data) => {
    var Inputs = {};
    data.keys.map((item) => {
      if (item.default && item.default !== '' && item.type !== "relation") {
        Inputs[item.name] = item.default;
      }
      if (item.type !== "relation") {
        Inputs[item.name] = item?.defaultbool || null;
      }
    });

    setInputvalues(Inputs);
    setRelationInputvalues({});
    var relationkeys = []
    data.keys.map((item) => {
      if (item.type === "relation") {
        relationkeys.push({
          ...item,
          mainId: true

        })
      }
    })
    if (data?.relationShipList.length > 0) {
      data?.relationShipList.map(item => {
        const keys = JSON.parse(item?.foreignJson).keys
        keys.map(i => {
          if (i.type === "relation" && item.name === i.name) {
            relationkeys.push({
              ...i,
              format: item.foreignId || data.TypeId,
              mainId: false
            })
          }
        })

      })
    }
    setSelectedType({
      ...data,
      relationShipList: relationkeys
    });
    setistable(false);
    // stDataStatus(0)
  };
  const handledata = async (data) => {
    try {
      const response5 = await Axios.get(
        `${CMS_API_URL}/submission/getContent/${data.plural}/${domainId}`,
      );
      setPagination(response5.data.data.metaData?.pagination);
      var response = {
        data: {
          data: response5.data.data.submissions || [],
        },
      };
      if (response?.data?.data[0]) {
        seteditid(response.data?.data[0]?.submissionId);
      }

      if (response.data?.data[0]?.answerJson) {
        var dataset = JSON.parse(response.data?.data[0]?.answerJson);
        for (let key in dataset) {
          if (typeof dataset[key] === 'string' && isJsonString(dataset[key])) {
            dataset[key] = JSON.parse(dataset[key]);
          }
        }

        setInputvalues(dataset);
        var Relatiojndata = JSON.parse(response.data?.data[0]?.relationJson) || {};
        for (let key in Relatiojndata) {
          if (typeof Relatiojndata[key] === 'string' && isJsonString(Relatiojndata[key])) {
            Relatiojndata[key] = JSON.parse(Relatiojndata[key]);
          }
        }
        setRelationInputvalues(Relatiojndata);
        setOldRelationInputvalues(Relatiojndata);
      } else {
        var Inputs = {};
        data.keys.map((item) => {
          if (item.default && item.default !== '') {
            Inputs[item.name] = item.default;
          }
        });
        setInputvalues(Inputs);
      }
      var product = {
        ...response.data?.data[0],
        answerJson: response.data?.data[0]?.answerJson ? JSON.parse(response.data?.data[0]?.answerJson) : {},
      };
      EditSubmitions(product, data)
      setCreationdata({
        createdon: response.data?.data[0] ? formatDate(response.data?.data[0]?.createdAt) : '',
        createdby: response.data?.data[0] ? 'Anubhav Sharma' : '',
        updatedby: response.data?.data[0] ? 'Anubhav Sharma' : '',
        updatedon: response.data?.data[0] ? formatDate(response.data?.data[0]?.updatedAt) : '',
      });
      setisPublish(response.data?.data[0]?.status);
      setSelectedType(data);
      setCollectionType(null);
      setistable(false);
      setloading(false);

    } catch (error) {
      console.error(error);
    }
  };


  const handleComponent = (comp, name, value, i) => {
    setInputvalues({
      ...Inputvalues,
      [comp]: {
        ...Inputvalues[comp],
        [name]: value,
      },
    });
  };
  const handleArrayComponent = (comp, name, value, i) => {

    setInputvalues((prevInputValues) => ({
      ...prevInputValues,
      [comp]:
        typeof prevInputValues[comp] !== 'object' || prevInputValues[comp].length === undefined
          ? [
            {
              [name]: value,
            },
          ]
          : prevInputValues[comp].map((item, index) => {
            if (index === i) {
              return {
                ...item,
                [name]: value,
              };
            }
            return item;
          }),
    }));
  };

  const handleNewAdd = (comp, name) => {
    setInputvalues((prevInputValues) => ({
      ...prevInputValues,
      [comp]: Array.isArray(prevInputValues[comp]) ? [...prevInputValues[comp], {}] : [{}],
    }));
  };
  const handleDeleteOld = (comp, name, index) => {
    setInputvalues((prevInputValues) => ({
      ...prevInputValues,
      [comp]: Array.isArray(prevInputValues[comp])
        ? [...prevInputValues[comp].slice(0, index), ...prevInputValues[comp].slice(index + 1)]
        : [{}],
    }));
  };


  const getComponrnt = (item) => {

    var id = item.Component;
    var fullitem = item;
    const keyname = fullitem.name;
    const data = Components.filter((item) => item.id === id);

    return (
      <div className="">
        <h6 className="Component-title">{keyname}</h6>
        <div className="Component-Content  h-100 ">
          {data[0]?.keys?.length > 0 ? (
            <div className="row">
              {data[0].keys.map((item, index) => {
                var resultArray = [];
                if (item.type === 'Component') {
                  resultArray = Array.from(
                    { length: Inputvalues?.[keyname]?.[item.name]?.length },
                    (_, index) => index + 1,
                  );
                }

                return item.type === 'dropzone' ? (
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3 dropdownclass" key={index}>
                    <InputC disabled={!!OverlaySelectedType || !isDraft} label={item.name} />
                    <div className="Dropzone">
                      <div className="d-flex justify-content-center dropzone-font-size">
                        {Inputvalues?.[keyname]?.[item?.name] && Inputvalues[keyname]?.[item?.name]?.length > 0 ? (
                          <div className="">
                            {/* <img src={Inputvalues?.[item.name][0].src} /> */}
                            {/* <p>
                                                                Drag and drop file here or <span className="color-underline">Choose file</span>
                                                            </p>
                                                            <p>
                                                                {
                                                                    Inputvalues[keyname][item?.name]?.length > 0 &&
                                                                    (
                                                                        <>
                                                                            <span> {Inputvalues[keyname][item?.name]?.length} </span> Media File Selected <span className="color-underline"></span>
                                                                        </>
                                                                    )

                                                                }
                                                            </p> */}
                            <CarousalC
                              disabled={!!OverlaySelectedType || !isDraft}
                              click={() => toggleComponentmodel(item, keyname, item?.name)}
                              item={item}
                              items={Inputvalues?.[keyname]?.[item?.name].map(formatData)}
                            />

                            {/* <span>( {Inputvalues?.[item.name].length} )</span> */}
                          </div>
                        ) : (
                          <div
                            style={{ opacity: !!OverlaySelectedType || !isDraft ? 0.5 : 1 }}
                            onClick={() => {
                              if (!!OverlaySelectedType || !isDraft) {
                                return;
                              }
                              toggleComponentmodel(item, keyname, item?.name);
                            }}
                          >
                            <div className="d-flex justify-content-center">{SVG.Dropzone}</div>

                            <p>
                              Drag and drop file here or{' '}
                              <span className="color-underline">Choose file</span>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : item.type === 'JSON' ? (
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-3" key={index}>
                    <InputC
                      isClearable={true}
                      label={item.name}
                      name={item.name}
                      type={'json'}
                      placeholder={item.name}
                      inputvalue={
                        Inputvalues?.[keyname] ? Inputvalues?.[keyname]?.[item?.name] || undefined : ''
                      }
                      required={item.required}
                      size="sm"
                      disabled={!!OverlaySelectedType || !isDraft}
                      // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                      change={(e) => handleComponent(keyname, item.name, e.json)}
                    />
                  </div>
                ) : item.type === 'Component' ? (
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                    {' '}
                    {resultArray.length > 0 && item.repeatable ? (
                      <>
                        {resultArray.map((data, index) => {
                          return getNestedArrayComponrnt(item, index, fullitem, null);
                        })}
                        {/* {getNestedArrayComponrnt(item, 1, true)} */}
                      </>
                    ) : item.repeatable ? (
                      getNestedArrayComponrnt(item, 0, fullitem, null, true)
                    ) : (
                      getNestedComponrnt(item, fullitem, true)
                    )}
                  </div>
                ) : (
                  <div
                    className={` ${item.type === 'editor' ? 'col-lg-12 col-md-12 col-sm-12 mt-3' : 'col-lg-6 col-md-6 col-sm-12 mt-3'}`}
                    key={index}
                  >
                    <InputC
                      isClearable={true}
                      label={item.name}
                      name={item.name}
                      type={
                        item.type === 'UUID'
                          ? 'text'
                          : item.type === 'editor'
                            ? 'CMSeditor'
                            : item.type === 'text'
                              ? item.Type === 2 ? 'TextArea' : item.type
                              : item.type
                      }
                      placeholder={item.name}
                      options={item?.predefine ? PredefinedValues[item.predefineoption] : item.options}
                      required={item.required}
                      isEdit={item?.isMulti}
                      isMulti={item?.isMulti}
                      size="sm"
                      disabled={!!OverlaySelectedType || !isDraft}
                      inputvalue={
                        Inputvalues?.[keyname] ? Inputvalues?.[keyname]?.[item?.name] || undefined : ''
                      }
                      change={(e) => {
                        e = handleValidation(item, e);

                        if (item.type === 'editor') {
                          handleComponent(keyname, item.name, e);
                        } else {
                          handleComponent(keyname, e.target.name, e.target.value);
                        }
                      }}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="w-25">
                <Nodatacomponent text="No Structure is Found" />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const getArrayComponrnt = (item, i, showadd = false) => {
    var fullitem = item;

    var id = item.Component;
    const data = Components.filter((item) => item.id === id);
    const keyname = fullitem.name;

    if (showadd) {
      return (
        <div>
          <div className="d-flex justify-content-between cursor-pointer">
            <h6 className="Component-title">{i === 0 && keyname}</h6>
          </div>
          <div className="Component-Design" onClick={(e) => handleNewAdd(keyname, e.target.name)}>
            <div className="add-Button-component">
              <span>+</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="">
        <div className="d-flex justify-content-between cursor-pointer">
          <h6 className="Component-title">{i === 0 && keyname}</h6>
          {
            item.repeatable &&
            (i === 0 ? (
              <h6
                className="Component-title"
                onClick={(e) => handleNewAdd(keyname, e.target.name)}
              >
                {' '}
                + Add New Data{' '}
              </h6>
            ) : (
              <h6
                className="Component-title"
                onClick={(e) => handleDeleteOld(keyname, e.target.name, i)}
              >
                { }
              </h6>
            )) //SVG.delete
          }
        </div>

        {/* onClick={() => handlecollapse(keyname + i)} */}

        <div className="Component-Design">
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center cursor-pointer"
                onClick={() => handlecollapse(keyname + i)}
              >
                <div style={{ rotate: Collapsediv[keyname + i] ? '270deg' : '0deg' }}>
                  {' '}
                  {SVG.arrow}{' '}
                </div>
                {keyname} {i + 1}
              </div>
              <h6
                className="Component-title"
                onClick={(e) => handleDeleteOld(keyname, e.target.name, i)}
              >
                {SVG.delete}
              </h6>
            </div>
          </div>
          <Collapse isOpen={Collapsediv[keyname + i]} className="">
            <div className="Component-Content  h-100 ">
              {data[0]?.keys.length > 0 ? (
                <div className="row">
                  {data[0]?.keys.map((item, index) => {
                    var resultArray = [];
                    if (item.type === 'Component') {
                      resultArray = Array.from(
                        { length: Inputvalues[keyname][i][item.name]?.length },
                        (_, index) => index + 1,
                      );
                    }
                    return item.type === 'dropzone' ? (
                      <div className="col-lg-6 col-md-6 col-sm-12 mt-3 dropdownclass" key={index}>
                        <InputC disabled={!!OverlaySelectedType || !isDraft} label={item.name} />
                        <div className="Dropzone">
                          <div className="d-flex justify-content-center dropzone-font-size">
                            {Inputvalues[keyname] &&
                              Inputvalues[keyname][i][item?.name]?.length > 0 ? (
                              <div className="">
                                {/* <img src={Inputvalues?.[item.name][0].src} /> */}
                                {/* <p>
                                                                        Drag and drop file here or <span className="color-underline">Choose file</span>
                                                                    </p>
                                                                    <p>
                                                                        <span> {Inputvalues[keyname][i] && Inputvalues[keyname][i][item?.name]?.length} </span> Media File Selected <span className="color-underline"></span>
                                                                    </p> */}
                                {Inputvalues[keyname][i] && (
                                  <CarousalC
                                    disabled={!!OverlaySelectedType || !isDraft}
                                    click={() =>
                                      toggleArrayComponentmodel(item, keyname, i, item?.name)
                                    }
                                    item={item}
                                    items={
                                      Inputvalues?.[keyname]?.[i]?.[item?.name]?.map(formatData) ||
                                      []
                                    }
                                  />
                                )}

                                {/* <span>( {Inputvalues?.[item.name].length} )</span> */}
                              </div>
                            ) : (
                              <div
                                style={{ opacity: !!OverlaySelectedType || !isDraft ? 0.5 : 1 }}
                                onClick={() => {
                                  if (!!OverlaySelectedType || !isDraft) {
                                    return;
                                  }
                                  toggleArrayComponentmodel(item, keyname, i, item?.name);
                                }}
                              >
                                <div className="d-flex justify-content-center">{SVG.Dropzone}</div>
                                <p>
                                  Drag and drop file here or{' '}
                                  <span className="color-underline">Choose file</span>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : item.type === 'Component' ? (
                      <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                        {resultArray.length > 0 && item.repeatable
                          ? resultArray.map((data, index) => {
                            return getNestedArrayComponrnt(item, index, fullitem, i);
                          })
                          : item.repeatable
                            ? getNestedArrayComponrnt(item, 0, fullitem, i, true)
                            : getNestedComponrnt(item, fullitem, i, true)}
                      </div>
                    ) : item.type === 'JSON' ? (
                      <div className="col-lg-12 col-md-12 col-sm-12 mt-3" key={index}>
                        <InputC
                          disabled={!!OverlaySelectedType || !isDraft}
                          isClearable={true}
                          label={item.name}
                          name={item.name}
                          type={'json'}
                          placeholder={item.name}
                          inputvalue={
                            Inputvalues[keyname]
                              ? Inputvalues[keyname][i]
                                ? Inputvalues[keyname][i][item?.name] || undefined
                                : undefined
                              : ''
                          }
                          required={item.required}
                          size="sm"
                          // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                          change={(e) => handleArrayComponent(keyname, item.name, e.json, i)}
                        />
                      </div>
                    ) : (
                      <div
                        className={` ${item.type === 'editor' ? 'col-lg-12 col-md-12 col-sm-12 mt-3' : 'col-lg-6 col-md-6 col-sm-12 mt-3'}`}
                        key={index}
                      >
                        <InputC
                          disabled={!!OverlaySelectedType || !isDraft}
                          isClearable={true}
                          label={item.name}
                          name={item.name}
                          type={
                            item.type === 'UUID'
                              ? 'text'
                              : item.type === 'editor'
                                ? 'CMSeditor'
                                : item.type === 'text'
                                  ? item.Type === 2 ? 'TextArea' : item.type
                                  : item.type
                          }
                          placeholder={item.name}
                          options={item?.predefine ? PredefinedValues[item.predefineoption] : item.options}
                          isEdit={item?.isMulti}
                          isMulti={item?.isMulti}
                          required={item.required}
                          size="sm"
                          inputvalue={(() => {
                            try {
                              if (!Inputvalues || !keyname) return '';

                              if (item.type === 'select') {
                                return Inputvalues[keyname]?.[i]?.[item?.name]?.value ?? undefined;
                              }

                              if (item.type === 'togglemode') {
                                return Inputvalues[keyname]?.[i]?.[item?.name] ?? undefined;
                              }

                              return Inputvalues[keyname]?.[i]?.[item?.name] ?? undefined;
                            } catch (error) {
                              console.error('Error accessing inputvalue:', error);
                              return undefined;
                            }
                          })()}
                          change={(e) => {
                            e = handleValidation(item, e);

                            if (item.type === 'editor' || item.type === 'select') {
                              handleArrayComponent(keyname, item.name, e, i);
                            } else if (item.type === 'togglemode') {
                              handleArrayComponent(
                                keyname,
                                item.name,
                                !Inputvalues[keyname][i][item?.name],
                                i,
                              );
                            } else {
                              handleArrayComponent(keyname, item.name, e.target.value, i);
                            }
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <div className="w-25">
                    <Nodatacomponent text="No Structure is Found" />
                  </div>
                </div>
              )}
            </div>
          </Collapse>
        </div>
      </div>
    );
  };

  // ========================================================= Nested Component ===========================================================================

  const handleNestedComponent = (comp, name, value, i, parent) => {
    setInputvalues((prevInputValues) => {
      // if (typeof updatedParent[i] === 'object') {
      var updatedParent;
      if (i !== undefined) {
        updatedParent = Array.isArray(prevInputValues[parent]) ? [...prevInputValues[parent]] : [];

        updatedParent[i] = {
          ...updatedParent[i],
          [comp]: {
            ...(updatedParent[i] ? updatedParent[i][comp] || {} : {}),
            [name]: value,
          },
        };
      } else {
        updatedParent = prevInputValues[parent] ? prevInputValues[parent] : {};
        updatedParent = {
          ...(updatedParent ? updatedParent : {}),
          [comp]: {
            ...(updatedParent ? updatedParent[comp] || {} : {}),
            [name]: value,
          },
        };
      }

      // }

      return {
        ...prevInputValues,
        [parent]: updatedParent,
      };
    });
  };
  // const handleArrayComponent = (comp, name, value, i) => {
  //     setInputvalues(prevInputValues => ({
  //         ...prevInputValues,
  //         [comp]: typeof (prevInputValues[comp]) !== "object" ?
  //             [
  //                 {
  //                     [name]: value,
  //                 }
  //             ]

  //             : prevInputValues[comp].map((item, index) => {
  //                 if (index === i) {
  //                     return {
  //                         ...item,
  //                         [name]: value,
  //                     };
  //                 }
  //                 return item;
  //             }),
  //     }));
  // };
  const handleNestedArrayComponent = (comp, name, value, i, parentname, parnetindex) => {
    setInputvalues((prevInputValues) => {
      const updateOrCreateArray = (array, index, newValue) => {
        if (!Array.isArray(array)) {
          return [{ [name]: newValue }];
        }
        return array.map((item, idx) => {
          if (idx === index) {
            return { ...item, [name]: newValue };
          }
          return item;
        });
      };

      const updatedParentArray =
        parnetindex !== undefined && parnetindex !== null
          ? prevInputValues[parentname]?.map((parentItem, idx) => {
            if (idx === parnetindex) {
              return {
                ...parentItem,
                [comp]: updateOrCreateArray(parentItem[comp], i, value),
              };
            }
            return parentItem;
          })
          : {
            ...(prevInputValues[parentname] ? prevInputValues[parentname] : {}),
            [comp]: updateOrCreateArray(prevInputValues[parentname]?.[comp], i, value),
          };

      return {
        ...prevInputValues,
        [parentname]: updatedParentArray,
      };
    });
  };

  const handleNestedNewAdd = (comp, parentname, parentindex, index) => {
    setInputvalues((prev) => {
      const currentParent = prev[parentname] || (parentindex !== undefined ? [] : {});

      if (parentindex !== undefined && parentindex !== null) {
        // Handle when parent is an array and we're targeting a specific item
        const parentArray = Array.isArray(currentParent) ? currentParent : [];
        const targetItem = parentArray[parentindex] || {};

        const nestedArray = Array.isArray(targetItem[comp]) ? targetItem[comp] : [];

        const updatedItem = {
          ...targetItem,
          [comp]: [...nestedArray, {}],
        };

        const updatedParent = [
          ...parentArray.slice(0, parentindex),
          updatedItem,
          ...parentArray.slice(parentindex + 1),
        ];

        return {
          ...prev,
          [parentname]: updatedParent,
        };
      } else {
        // Handle when parent is an object
        const nestedArray = Array.isArray(currentParent[comp]) ? currentParent[comp] : [];

        return {
          ...prev,
          [parentname]: {
            ...currentParent,
            [comp]: [...nestedArray, {}],
          },
        };
      }
    });
  };

  const handleNestedDeleteOld = (comp, parentname, parentindex, index) => {
    setInputvalues((prevInputValues) => {
      // Clone the parent array
      var updatedParent;
      if (parentindex !== undefined && parentindex !== null) {
        updatedParent = [...prevInputValues[parentname]];
      } else {
        updatedParent = prevInputValues[parentname];
      }

      // Clone the specific object at parentindex
      var parentObject;
      if (parentindex !== undefined && parentindex !== null) {
        parentObject = { ...updatedParent[parentindex] };
      } else {
        parentObject = { ...updatedParent };
      }

      // Clone or initialize the nested array
      const nestedArray = Array.isArray(parentObject[comp]) ? [...parentObject[comp]] : [];

      if (index >= 0 && index < nestedArray.length) {
        // Delete the object at the specified index
        nestedArray.splice(index, 1);
      }

      // Update the nested array in the parent object
      parentObject[comp] = nestedArray;

      if (parentindex !== undefined && parentindex !== null) {
        updatedParent[parentindex] = parentObject;
      } else {
        updatedParent = parentObject;
      }
      // Return the new state
      return {
        ...prevInputValues,
        [parentname]: updatedParent,
      };
    });
  };

  const getNestedComponrnt = (Child, parent, i, showadd = false) => {
    var id = Child.Component;

    var fullitem = Child;
    var item = Child;
    const keyname = fullitem.name;
    const parentname = parent.name;
    const data = Components.filter((item) => item.id === id);

    if (showadd) {
      return (
        <div>
          <div className="d-flex justify-content-between cursor-pointer">
            <h6 className="Component-title">{i === 0 && keyname}</h6>
          </div>
          <div className="Component-Design" onClick={(e) => handleNestedNewAdd(keyname, parent.name, i)}>
            <div className="add-Button-component">
              <span>+</span>
            </div>
          </div>
        </div>
      );
    }



    return (
      <div className="">
        <div className="d-flex justify-content-between cursor-pointer">
          <h6 className="Component-title">{keyname}</h6>
          {item.repeatable &&
            (i === 0 ? (
              <h6
                className="Component-title"
                onClick={(e) => handleNestedNewAdd(keyname, parent.name, i)}
              >
                {' '}
                + Add New Data{' '}
              </h6>
            ) : (
              <h6
                className="Component-title"
                onClick={(e) => handleNestedDeleteOld(keyname, parent.name, i)}
              >
                {SVG.delete}
              </h6>
            ))}
        </div>
        <div className="Component-Content  h-100 ">
          {data[0]?.keys.length > 0 ? (
            <div className="row">
              {data[0]?.keys.map((item, index) => {
                var resultArray = [];
                if (item.type === 'Component') {
                  resultArray = Array.from(
                    { length: Inputvalues[parentname][i][keyname]?.length },
                    (_, index) => index + 1,
                  );
                }
                return item.type === 'dropzone' ? (
                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3 dropdownclass" key={index}>
                    <InputC disabled={!!OverlaySelectedType || !isDraft} label={item.name} />
                    <div className="Dropzone">
                      <div className="d-flex justify-content-center dropzone-font-size">
                        {Inputvalues?.[parentname]?.[keyname]?.[item?.name] &&
                          Inputvalues?.[parentname]?.[keyname]?.[item?.name].length > 0 ? (
                          <div className="">
                            {/* <img src={Inputvalues?.[item.name][0].src} /> */}
                            {/* <p>
                                                                Drag and drop file here or <span className="color-underline">Choose file</span>
                                                            </p>
                                                            <p>
                                                                <span> {Inputvalues[keyname] && Inputvalues[keyname][i][item?.name]?.length} </span> Media File Selected <span className="color-underline"></span>
                                                            </p> */}
                            {Inputvalues?.[parentname]?.[keyname]?.[item?.name] &&
                              Inputvalues?.[parentname]?.[keyname]?.[item?.name].length > 0 && (
                                <CarousalC
                                  disabled={!!OverlaySelectedType || !isDraft}
                                  click={() =>
                                    toggleNestedComponentmodel(
                                      item,
                                      keyname,
                                      false,
                                      item?.name,
                                      parentname,
                                    )
                                  }
                                  item={item}
                                  items={Inputvalues?.[parentname]?.[keyname]?.[item?.name]?.map(
                                    formatData,
                                  )}
                                />
                              )}

                            {/* <span>( {Inputvalues?.[item.name].length} )</span> */}
                          </div>
                        ) : (
                          <div
                            style={{ opacity: !!OverlaySelectedType || !isDraft ? 0.5 : 1 }}
                            onClick={() => {
                              if (!!OverlaySelectedType || !isDraft) {
                                return;
                              }
                              toggleNestedComponentmodel(item, keyname, i, item?.name, parentname);
                            }}
                          >
                            <div className="d-flex justify-content-center">{SVG.Dropzone}</div>
                            <p>
                              Drag and drop file here or{' '}
                              <span className="color-underline">Choose file</span>
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : item.type === 'Component' ? (
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                    {/* {
                                        resultArray.length > 0 ?
                                            resultArray.map((data, index) => {
                                                return getNestedSingleArrayComponrnt(item, index, data)
                                            }

                                            )
                                            :
                                            item.repeatable ?
                                                getNestedSingleArrayComponrnt(item, 0, data)
                                                :
                                                getNestedSingleComponrnt(item, data)
                                    } */}
                  </div>
                ) : item.type === 'JSON' ? (
                  <div className="col-lg-12 col-md-12 col-sm-12 mt-3" key={index}>
                    <InputC
                      disabled={!!OverlaySelectedType || !isDraft}
                      isClearable={true}
                      label={item.name}
                      name={item.name}
                      type={'json'}
                      placeholder={item.name}
                      inputvalue={
                        i !== undefined
                          ? (Inputvalues?.[parentname]?.[i]?.[keyname]?.[item?.name] ?? undefined)
                          : (Inputvalues?.[parentname]?.[keyname]?.[item?.name] ?? undefined)
                      }
                      required={item.required}
                      size="sm"
                      // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                      change={(e) =>
                        handleNestedComponent(keyname, item.name, e.json, undefined, parentname)
                      }
                    />
                  </div>
                ) : (
                  <div
                    className={` ${item.type === 'editor' ? 'col-lg-12 col-md-12 col-sm-12 mt-3' : 'col-lg-6 col-md-6 col-sm-12 mt-3'}`}
                    key={index}
                  >
                    <InputC
                      disabled={!!OverlaySelectedType || !isDraft}
                      isClearable={true}
                      label={item.name}
                      name={item.name}
                      type={
                        item.type === 'UUID'
                          ? 'text'
                          : item.type === 'editor'
                            ? 'CMSeditor'
                            : item.type === 'text'
                              ? item.Type === 2 ? 'TextArea' : item.type
                              : item.type
                      }
                      placeholder={item.name}
                      options={item?.predefine ? PredefinedValues[item.predefineoption] : item.options}
                      required={item.required}
                      size="sm"
                      inputvalue={
                        i !== undefined
                          ? (Inputvalues?.[parentname]?.[i]?.[keyname]?.[item?.name] ?? undefined)
                          : (Inputvalues?.[parentname]?.[keyname]?.[item?.name] ?? undefined)
                      }
                      change={(e) => {
                        e = handleValidation(item, e);

                        if (item.type === 'editor') {
                          handleNestedComponent(keyname, item.name, e, undefined, parentname);
                        } else {
                          handleNestedComponent(
                            keyname,
                            e.target.name,
                            e.target.value,
                            undefined,
                            parentname,
                          );
                        }
                      }}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="w-25">
                <Nodatacomponent text="No Structure is Found" />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const getNestedArrayComponrnt = (item, i, parent, parnetindex, showadd = false) => {
    var fullitem = item;
    var id = item.Component;
    const data = Components.filter((item) => item.id === id);
    const keyname = fullitem.name;
    const parentname = parent.name;
    if (showadd) {
      return (
        <div>
          <div className="d-flex justify-content-between cursor-pointer">
            <h6 className="Component-title">{i === 0 && keyname}</h6>
          </div>
          <div className="Component-Design" onClick={(e) => handleNestedNewAdd(keyname, parent.name, parnetindex)}>
            <div className="add-Button-component">
              <span>+</span>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="">
        <div className="d-flex justify-content-between cursor-pointer">
          <h6 className="Component-title">{i === 0 && keyname}</h6>
          {
            item.repeatable &&
            (i === 0 ? (
              <h6
                className="Component-title"
                onClick={(e) => handleNestedNewAdd(keyname, parent.name, parnetindex)}
              >
                {' '}
                + Add New Data{' '}
              </h6>
            ) : (
              <h6
                className="Component-title"
                onClick={(e) => handleNestedDeleteOld(keyname, parent.name, parnetindex, i)}
              >
                { }
              </h6>
            )) //SVG.delete
          }
        </div>
        <div className="Component-Design">
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div
                className="d-flex align-items-center cursor-pointer"
                onClick={() => handlecollapse(keyname + i)}
              >
                <div style={{ rotate: !Collapsediv[keyname + i] ? '270deg' : '0deg' }}>
                  {' '}
                  {SVG.arrow}{' '}
                </div>
                {keyname} {i + 1}
              </div>
              <h6
                className="Component-title"
                style={{ cursor: 'pointer' }}
                onClick={(e) => handleNestedDeleteOld(keyname, parent.name, parnetindex, i)}
              >
                {SVG.delete}
              </h6>
            </div>
          </div>
          <Collapse isOpen={Collapsediv[keyname + i]} className="">
            <div className="Component-Content  h-100 ">
              {data[0]?.keys.length > 0 ? (
                <div className="row">
                  {data[0]?.keys.map((item, index) => {
                    var resultArray = [];
                    if (item.type === 'Component') {
                      resultArray = Array.from(
                        { length: Inputvalues?.[parentname]?.[i]?.[keyname]?.length },
                        (_, index) => index,
                      );
                    }
                    const isValidIndex = parnetindex !== undefined && parnetindex !== null;

                    const Value = isValidIndex
                      ? Inputvalues?.[parent.name]?.[parnetindex]?.[keyname]?.[i]?.[item?.name]
                      : Inputvalues?.[parent.name]?.[keyname]?.[i]?.[item?.name];



                    // var dat=Inputvalues[parentname][i][keyname][parnetindex][item?.name]
                    return item.type === 'dropzone' ? (
                      <div className="col-lg-6 col-md-6 col-sm-12 mt-3 dropdownclass" key={index}>
                        <InputC disabled={!!OverlaySelectedType || !isDraft} label={item.name} />
                        <div className="Dropzone">
                          <div className="d-flex justify-content-center dropzone-font-size">
                            {Value &&
                              Value
                                .length > 0 ? (
                              <div className="">
                                {/* <img src={Inputvalues?.[item.name][0].src} /> */}
                                {/* <p>
                                                                        Drag and drop file here or <span className="color-underline">Choose file</span>
                                                                    </p>
                                                                    <p>
                                                                        <span> {Inputvalues[keyname] && Inputvalues[keyname][i][item?.name]?.length} </span> Media File Selected <span className="color-underline"></span>
                                                                    </p> */}

                                <CarousalC
                                  disabled={!!OverlaySelectedType || !isDraft}
                                  click={() =>
                                    toggleNestedNestedArrayComponentmodel(
                                      item,
                                      keyname,
                                      i,
                                      item?.name,
                                      parent.name,
                                      parnetindex,
                                    )
                                  }
                                  item={item}
                                  items={Value.map(formatData)}
                                />

                                {/* <span>( {Inputvalues?.[item.name].length} )</span> */}
                              </div>
                            ) : (
                              <div
                                style={{ opacity: !!OverlaySelectedType || !isDraft ? 0.5 : 1 }}
                                onClick={() => {
                                  if (!!OverlaySelectedType || !isDraft) {
                                    return;
                                  }
                                  toggleNestedNestedArrayComponentmodel(
                                    item,
                                    keyname,
                                    i,
                                    item?.name,
                                    parent.name,
                                    parnetindex,
                                  );
                                }}
                              >
                                <div className="d-flex justify-content-center">{SVG.Dropzone}</div>
                                <p>
                                  Drag and drop file here or{' '}
                                  <span className="color-underline">Choose file</span>
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : item.type === 'Component' ? (
                      <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                        {' '}
                        {resultArray.length > 0
                          ? resultArray.map((data, index) => {
                            return getNestedArrayComponrnt(item, index, data, i);
                          })
                          : item.repeatable
                            ? getNestedArrayComponrnt(item, 0, data, i, true)
                            : getNestedComponrnt(item, data, i, true)}
                      </div>
                    ) : item.type === 'JSON' ? (
                      <div className="col-lg-12 col-md-12 col-sm-12 mt-3" key={index}>
                        <InputC
                          disabled={!!OverlaySelectedType || !isDraft}
                          isClearable={true}
                          label={item.name}
                          name={item.name}
                          type={'json'}
                          placeholder={item.name}
                          inputvalue={
                            parnetindex !== undefined && parnetindex !== null
                              ? (Inputvalues?.[parentname]?.[parnetindex]?.[keyname]?.[i]?.[
                                item?.name
                              ] ?? undefined)
                              : (Inputvalues?.[parentname]?.[keyname]?.[i]?.[item?.name] ??
                                undefined)
                          }
                          required={item.required}
                          size="sm"
                          // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                          change={(e) =>
                            handleNestedArrayComponent(
                              keyname,
                              item.name,
                              e.json,
                              i,
                              parentname,
                              parnetindex,
                            )
                          }
                        />
                      </div>
                    ) : (
                      <div
                        className={` ${item.type === 'editor' ? 'col-lg-12 col-md-12 col-sm-12 mt-3' : 'col-lg-6 col-md-6 col-sm-12 mt-3'}`}
                        key={index}
                      >
                        <InputC
                          disabled={!!OverlaySelectedType || !isDraft}
                          isClearable={true}
                          label={item.name}
                          name={item.name}
                          type={
                            item.type === 'UUID'
                              ? 'text'
                              : item.type === 'editor'
                                ? 'CMSeditor'
                                : item.type === 'text'
                                  ? item.Type === 2 ? 'TextArea' : item.type
                                  : item.type
                          }
                          placeholder={item.name}
                          isEdit={item?.isMulti}
                          isMulti={item?.isMulti}
                          options={item?.predefine ? PredefinedValues[item.predefineoption] : item.options}
                          required={item.required}
                          size="sm"
                          inputvalue={
                            parnetindex !== undefined && parnetindex !== null
                              ? (Inputvalues?.[parentname]?.[parnetindex]?.[keyname]?.[i]?.[
                                item?.name
                              ] ?? undefined)
                              : (Inputvalues?.[parentname]?.[keyname]?.[i]?.[item?.name] ??
                                undefined)
                          }
                          change={(e) => {
                            e = handleValidation(item, e);

                            if (item.type === 'editor') {
                              handleNestedArrayComponent(
                                keyname,
                                item.name,
                                e,
                                i,
                                parentname,
                                parnetindex,
                              );
                            } else {
                              handleNestedArrayComponent(
                                keyname,
                                e.target.name,
                                e.target.value,
                                i,
                                parentname,
                                parnetindex,
                              );
                            }
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <div className="w-25">
                    <Nodatacomponent text="No Structure is Found" />
                  </div>
                </div>
              )}
            </div>
          </Collapse>
        </div>
        {/* <div className='Component-Design' >
                </div> */}
      </div>
    );
  };
  // ========================================================= Nested Component ===========================================================================
  const getImages = (item) => {
    const array = [];

    const processValue = (value) => {
      if (Array.isArray(value)) {
        // Recursively process each element in the array
        value.forEach(processValue);
      } else if (value && typeof value === 'object') {
        // Check for fileOriginalName and id
        if (value.fileOriginalName && value.id) {
          array.push(value.id);
        }
        // Check for mediaFileId
        if (value.mediaFileId) {
          array.push(value.mediaFileId);
        }
        // Recursively process nested objects
        Object.values(value).forEach(processValue);
      }
    };

    processValue(item);

    return array;
  };

  const handleInput = (name, value, item) => {
    if (item && !AdditionalValidation(item, name, value)) {
      return null;
    }

    setInputvalues({
      ...Inputvalues,
      [name]: value,
    });
  };
  const handleRelationInput = (name, value, item) => {
    setUpdateRelationInputvalues({
      ...UpdateRelationInputvalues,
      [name]: {
        name: name,
        ids: value,
        foreignPlural: item.foreignPlural,
        foreignId: item.foreignId,
        type: 'relation',
        relationShipName: item.relationShipName,
        relationShipType: item.relationShipType,
      },
    });
    setRelationInputvalues({
      ...RelationInputvalues,
      [name]: {
        name: name,
        ids: value,
        foreignPlural: item.foreignPlural,
        foreignId: item.foreignId,
        type: 'relation',
        relationShipName: item.relationShipName,
        relationShipType: item.relationShipType,
      },
    });
  };

  const handleUUIDInput = (name, value) => {
    // Validate the input value for UUID format
    if (value !== '') {
      const isValidUUID = /^[a-zA-Z0-9-_]+$/.test(value);

      if (!isValidUUID) {
        toast.error(`${name} must contain only letters, numbers, hyphens (-), and underscores (_)`);
        return;
      }
    }

    setInputvalues({
      ...Inputvalues,
      [name]: value,
    });
  };

  const handleTextInput = (name, value, type, item) => {
    if (!AdditionalValidation(item, name, value)) {
      return null;
    }

    if (type === 1) {
      if (value.length > 255) {
        toast.error('Length cannot exceed 255 characters');
        return; // Exit early if length exceeds limit
      }
    }

    setInputvalues({
      ...Inputvalues,
      [name]: value,
    });
  };

  const handleJSONInput = (name, value) => {
    setInputvalues({
      ...Inputvalues,
      [name]: value,
    });
  };

  const handleInputChange = (name, value, format, item) => {
    let formattedValue = value;
    // Add decimal point if missing in decimal format
    if (!AdditionalValidation(item, name, value)) {
      return null;
    }
    if (format === 'int' || format === 'Bigint') {
      formattedValue = value.replace(/[^\d]/g, ''); // Remove any non-digit characters
    }

    // if (format === 'decimal' && !value.includes('.') && value > 0) {
    //     formattedValue += '.00';
    // }

    // // Format float to two decimal places
    // if (format === 'float') {
    //     // Parse the input value as a float and round it to two decimal places
    //     formattedValue = parseFloat(value).toFixed(2);
    // }

    setInputvalues({
      ...Inputvalues,
      [name]: formattedValue,
    });
  };
  //** ======================================= Collection Table ===================================================== */


  const [header, setheader] = useState([]);
  var defaultdata = [
    {
      id: 3,
      title: 'CreatedAt',
      checked: true,
      width: '10%',
      key: 'createdAt',
    },
    {
      id: 4,
      title: 'UpdatedAt',
      width: '10%',
      key: 'updatedAt',
      checked: true,

    },
    {
      id: 5,
      title: 'Status',
      // width: '10%',
      checked: true,
      key: 'children',
      children: (item) => {
        const value = getStatus(item.status, item.draftStatus);
        const style = StatusClasses[value];

        return (
          <span
            className="text-xs font-semibold text-gray-500"
            style={{
              border: '1px solid #4a4a6a',
              padding: '4px 0.5rem',
              fontWeight: 'bold',
              fontSize: '14px',
              borderRadius: '4px',
              background: style.bacground,
              color: style.text,
            }}
          >
            {StatusValues[value]}
          </span>
        )
      }
    },
    {
      id: 6,
      title: '',
      // width: '20%',
      key: 'button',
      checked: true,

    }
  ]



  useEffect(() => {
    if (!CollectionType?.keys?.length) return;
    setloadingdata(true);
    const headers = [];
    const defaultHeaders = [];

    CollectionType.keys.forEach((item, i) => {
      if (item.type === "Component" || item.type === "dropzone" || item.type === "relation") return;
      const column = {
        id: 5 + i,
        title: item.name || `Field ${i + 1}`,
        key: "children",
        value: item.name,
        children: (data) => {
          if (item.type === "select") {
            return (
              <span title={data.answerJson?.[item.name]?.label}>
                {(data.answerJson?.[item.name]?.label?.length > 50
                  ? data.answerJson[item.name]?.label.slice(0, 50) + "..."
                  : data.answerJson?.[item.name]?.label) || "N/A"}
              </span>
            )
          } else {
            return (
              <span title={data.answerJson?.[item.name]}>
                {(data.answerJson?.[item.name]?.length > 50
                  ? data.answerJson[item.name].slice(0, 50) + "..."
                  : data.answerJson?.[item.name]) || "N/A"}
              </span>
            )
          }

        },
      };
      // default selected (text / UUID) – only first 2
      if (
        (item.type === "text" || item.type === "UUID") &&
        headers.length < 2
      ) {
        headers.push(column);
        defaultHeaders.push({ ...column, checked: true });
      } else {
        defaultHeaders.push({ ...column, checked: false });
      }
    });
    setheader([...defaultHeaders, ...defaultdata]);
    setloadingdata(false);
    // setdefaultheader(headers);
  }, [CollectionType]);



  const headerData = useMemo(() => {
    return [
      {
        id: 1,
        title: 'S.No.',
        key: 'S.No.',
        value: (currentpage - 1) * pagesize,
      },
      ...(header?.length > 0
        ? header.filter((i) => i.checked)
        : [
          {
            id: 2,
            title: 'id',
            key: 'submissionId',
          },
        ]),
    ];
  }, [header, currentpage, pagesize]);

  const EditSubmitions = (product, dataCollectionType) => {
    setloading(true);
    seteditid(product.submissionId);

    const statusvalue = getStatus(product.status, product.draftStatus);
    stDataStatus(statusvalue);
    setisPublish(product.status);
    setCreationdata({
      createdon: formatDate(product.createdAt),
      createdby: product.createdBy,
      updatedby: product.updatedBy,
      updatedon: formatDate(product.updatedAt),
    });
    handleCollectiondata(dataCollectionType);

    let data = product.answerJson || {};
    for (let key in data) {
      if (
        typeof data[key] === 'string' &&
        isJsonString(data[key]) &&
        data[key] !== 'undefined'
      ) {
        data[key] = JSON.parse(data[key]);
      }
    }

    let Relatiojndata = {};
    if (product?.relationJson && product.relationJson !== 'undefined') {
      try {
        Relatiojndata = JSON.parse(product.relationJson);
      } catch (e) {
        Relatiojndata = {};
      }
    }

    for (let key in Relatiojndata) {
      if (
        typeof Relatiojndata[key] === 'string' &&
        isJsonString(Relatiojndata[key]) &&
        Relatiojndata[key] !== 'undefined'
      ) {
        Relatiojndata[key] = JSON.parse(Relatiojndata[key]);
      }
    }

    if (product?.draftJson && product.draftJson !== 'undefined') {
      let datadraft = {};
      try {
        datadraft = JSON.parse(product.draftJson);
      } catch (e) {
        datadraft = {};
      }

      for (let key in datadraft) {
        if (
          typeof datadraft[key] === 'string' &&
          isJsonString(datadraft[key]) &&
          datadraft[key] !== 'undefined'
        ) {
          datadraft[key] = JSON.parse(datadraft[key]);
        }
      }

      setDraftJson(datadraft);
      setInputvalues(datadraft);
    } else {
      setDraftJson(data);
      setInputvalues(data);
    }

    if (product?.draftRelationJson && product.draftRelationJson !== 'undefined') {
      let relationJsondata = {};
      try {
        relationJsondata = JSON.parse(product.draftRelationJson);
      } catch (e) {
        relationJsondata = {};
      }

      for (let key in relationJsondata) {
        if (
          typeof relationJsondata[key] === 'string' &&
          isJsonString(relationJsondata[key]) &&
          relationJsondata[key] !== 'undefined'
        ) {
          relationJsondata[key] = JSON.parse(relationJsondata[key]);
        }
      }

      setRelationInputvalues(relationJsondata);
      setOldRelationInputvalues(relationJsondata);
      setDraftRelationInputvalues(relationJsondata);
    } else {
      setRelationInputvalues(Relatiojndata);
      setOldRelationInputvalues(Relatiojndata);
      setDraftRelationInputvalues(Relatiojndata);
    }

    setPublishRelationInputvalues(Relatiojndata);
    setAnswerJson(data);
    setloading(false);
  };


  const tablebutton = (product) => {
    return (
      <div className="d-flex justify-content-center gap-3">
        <div
          onClick={() => {
            navigator.clipboard
              .writeText(product.submissionId)
              .then(() => {
                toast.success('Text copied to clipboard successfully');
              })
              .catch((err) => {
                toast.error('Failed to copy text');
                console.error('Failed to copy text: ', err);
              });
          }}
        >
          {SVG.copy}
        </div>

        <div
          className="cursor-pointer"
          onClick={() =>
            navigate(
              `/CMS/contentmanager/${domainId}/collection/${pluralid}/${product.submissionId}`,
            )
          }
        >
          {SVG.edit}
        </div>

        <div
          className="cursor-pointer"
          onClick={() => {
            if (window.confirm('Are you sure you want to delete')) {
              handleDelete(product.submissionId);
            }
          }}
        >
          {SVG.delete}
        </div>
      </div>
    );
  };
  const RowClick = (product) => {
    if (product.datastatus === "Draft") {
      return
    }
    setCreationdata({
      createdon: formatDate(product.createdAt),
      createdby: product.createdBy,
      updatedby: product.updatedBy,
      updatedon: formatDate(product.updatedAt),
    });
    var data = product.answerJson;
    for (let key in data) {
      if (typeof data[key] === 'string' && isJsonString(data[key])) {
        data[key] = JSON.parse(data[key]);
      }
    }

    setOverlaySelectedType(CollectionType);

    setInputvalues(data);

    setDrawerOpen(true);
  };
  const handleUpdateTerms = (product) => {
    //call here the api for get conditions
  };

  //** ======================================= Collection Table ===================================================== */

  //** ======================================= DROPZONE MODEL ===================================================== */

  const [openmodel, setopenmodel] = useState(false);
  const [openComponentmodel, setopenComponentmodel] = useState(false);
  const [openComponentArraymodel, setopenArrayComponentmodel] = useState(false);
  const [openNestedComponentArraymodel, setopenNestedComponentArraymodel] = useState(false);
  const [openNestedNestedComponentArraymodel, setopenNestedNestedComponentArraymodel] =
    useState(false);
  const [openNestedComponentmodel, setopenNestedComponentmodel] = useState(false);

  const [Componentdata, setComponentdata] = useState(null);

  const togglemodel = (item) => {
    setComponentdata({
      data: item,
      component: null,
      selected: Inputvalues[item?.name],
      type: item?.Type,
    });
    setopenmodel(!openmodel);
  };

  const toggleComponentmodel = (item, comp, name) => {
    setComponentdata({
      data: item,
      component: comp,
      selected: Inputvalues[comp] ? Inputvalues[comp][name] : null,
      type: item?.Type,
    });
    setopenComponentmodel(!openComponentmodel);
  };
  const toggleArrayComponentmodel = (item, comp, i, name) => {
    setComponentdata({
      data: item,
      component: comp,
      selected: Inputvalues[comp] ? Inputvalues[comp][i][name] : null,
      type: item?.Type,
      index: i,
    });
    setopenArrayComponentmodel(!openComponentArraymodel);
  };

  const toggleNestedArrayComponentmodel = (item, comp, i, name, parent) => {
    setComponentdata({
      data: item,
      component: comp,
      selected: Inputvalues?.[parent]?.[comp]?.[i]?.[name]
        ? Inputvalues[parent][comp][i][name]
        : null,
      type: item?.Type,
      index: i,
      parent: parent,
    });
    setopenNestedComponentArraymodel(!openNestedComponentArraymodel);
  };
  const toggleNestedComponentmodel = (item, comp, i, name, parent) => {
    setComponentdata({
      data: item,
      component: comp,
      selected: Inputvalues?.[parent]?.[comp]?.[name] ? Inputvalues[parent][comp][name] : null,
      type: item?.Type,
      index: undefined,
      parent: parent,
    });
    setopenNestedComponentmodel(!openNestedComponentmodel);
  };

  const toggleNestedNestedArrayComponentmodel = (item, comp, i, name, parent, parentindex) => {
    const InputValue = parentindex ? Inputvalues?.[parent]?.[parentindex]?.[comp]?.[i]?.[name] : Inputvalues?.[parent]?.[comp]?.[i]?.[name]
    setComponentdata({
      data: item,
      component: comp,
      selected: InputValue
        ? InputValue
        : null,
      type: item?.Type,
      index: i,
      parent: parent,
      parentindex: parentindex,
    });
    setopenNestedNestedComponentArraymodel(!openNestedNestedComponentArraymodel);
  };

  //** ======================================= DROPZONE MODEL ===================================================== */
  const handleDelete = async (id) => {
    try {
      await Axios.delete(`${CMS_API_URL}/submission/delete/${id}/${domainId}`);
      await handlecollection(CollectionType);
    } catch (error) {
      console.error(error);
    }
  };

  const onSelect = (selectedList, selectedItem) => { };

  function onRemove(selectedList, removedItem) { }
  const handleKeyPress = (e, format, name) => {
    const key = e.keyCode || e.which;
    const keyChar = e.target.value;
    // Allow control keys (backspace, delete, arrows, etc.)
    if (e.ctrlKey || e.altKey || key < 32 || key === 37 || key === 36 || key === 38 || key === 40) {
      return true;
    }
    // Define regex patterns for different formats
    const formatPatterns = {
      int: /^\d$/,
      Bigint: /^\d$/,
      decimal: /^\d|\.|,$/,
      float: /^\d$|\.|,$/,
    };

    // Check if the format is recognized and if the keyChar matches the pattern
    if (formatPatterns[format] && !formatPatterns[format].test(keyChar)) {
      e.preventDefault();
      toast.error(`${name} must be in ${format} format`);
      return false;
    }

    return true;
  };
  const handleRebuild = async (domain) => {
    try {
      // Make the API call
      const response = await Axios.post(`${CMS_PUBLIC_API_URL}/data/purge/${domain}`);

      // Handle the success response
    } catch (error) {
      // Handle any errors
      console.error('Error purging Redis cache:', error);

      // Optionally, show a user-friendly message
      if (error.response) {
        // Server responded with a status other than 2xx
        toast.error(`Error: ${error.response.data.message || 'Unable to purge cache.'}`);
      } else if (error.request) {
        // No response was received
        toast.error('Error: No response received from the server. Please try again.');
      } else {
        // Other errors
        toast.error('An unexpected error occurred. Please try again.');
      }
    }
  };


  // ============================================ Relation ==============================================
  const loadRelationOptions = async (inputValue, item, callback) => {
    try {
      // Safely parse JSON
      var foreignJson;

      if (item?.foreignJson) {
        foreignJson = JSON.parse(item.foreignJson);
      } else {
        foreignJson = props.cms.collections.find(c => item.format === c.id)
      }

      // Construct key object array
      const key = foreignJson.keys
        .filter((item) => item.type === 'text' || item.type === 'UUID')
        .map((item, i) => ({
          id: 5 + i,
          title: item.name,
          key: 'answerJson',
          value: item.name,
        }))
        .slice(0, 1);

      // Axios request
      let response = await Axios.get(
        `${CMS_API_URL}/submission/getContent/${foreignJson.plural}/${domainId}?page=0&size=10000`,
      );
      setPagination(response.data.data.metaData?.pagination);

      // Extract submissions data
      const submissions = response.data.data.submissions;
      // Map API response to options
      const options = submissions.map((option) => {
        const statusvalue = getStatus(option.status, option.draftStatus);
        var answer
        if (statusvalue === 2) {
          answer = JSON.parse(option.draftJson);
        } else {
          answer = JSON.parse(option.answerJson);
        }


        return {
          label: answer?.[key[0]?.title] ? answer?.[key[0].title] : foreignJson.plural,
          value: option.submissionId,
          status: statusvalue,
        };
      });

      const newState = { ...RelationInputvalues };
      var arr = [];
      if (RelationInputvalues[item.name]?.ids) {
        const updatedIds = RelationInputvalues[item.name].ids.map((ite) => {
          const foundOption = options.find((data) => data.value === ite?.value);
          if (!arr.includes(ite.value)) {
            arr.push(ite.value);
            return foundOption || ite; // Fallback in case option is not found
          }
        });

        newState[item.name] = {
          ...RelationInputvalues[item.name],
          ids: updatedIds,
        };
      } else {
        newState[item.name] = {
          ...RelationInputvalues[item.name],
          ids: [], // Handle empty state
        };
      }

      setTimeout(() => {
        callback(options);

        // handleRelationInput(item.name, newState[item.name].ids, item);


        UpdateRelationInputvalue = {
          ...UpdateRelationInputvalue,
          [item.name]: {
            name: item.name,
            ids: newState[item.name].ids,
            foreignPlural: item.foreignPlural,
            foreignId: item.foreignId,
            type: 'relation',
            relationShipName: item.relationShipName,
            relationShipType: item.relationShipType,
          },
        };

        setUpdateRelationInputvalues({
          ...UpdateRelationInputvalue,
          [item.name]: {
            name: item.name,
            ids: newState[item.name].ids,
            foreignPlural: item.foreignPlural,
            foreignId: item.foreignId,
            type: 'relation',
            relationShipName: item.relationShipName,
            relationShipType: item.relationShipType,
          },
        });
      }, 200); // Optional delay for user experience, can be removed
    } catch (error) {
      console.error('Error loading relation options:', error);
      callback([]); // Return empty options on error
    }
  };

  // ============================================ Relation ==============================================

  const [Donloadloading, setDonloadloading] = useState(false);

  const handleDownload = async () => {
    setDonloadloading(true);
    try {
      const response = await Axios.post(
        `${CMS_API_URL}/submission/download/${pluralid}/${domainId}`,
        {}, // empty request body
        {
          responseType: 'blob', // set response type here
        },
      );

      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'downloaded_file.pdf'; // Default file name

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (fileNameMatch.length > 1) {
          fileName = fileNameMatch[1];
        }
      }

      // Use FileSaver to save the file
      saveAs(new Blob([response.data]), fileName);

      setDonloadloading(false);
    } catch (error) {
      console.error(error);
      setDonloadloading(false);
    }
  };

  // =====================================================================================================
  // ======================================== Status Functions ===========================================
  // =====================================================================================================

  const handleSubmit = async (e) => {
    e.preventDefault();
    var images = getImages(Inputvalues);
    setDraftJson(Inputvalues);
    setDraftRelationInputvalues(RelationInputvalues);
    setUpdateRelationInputvalues(RelationInputvalues);
    setOldRelationInputvalues(RelationInputvalues);


    try {
      setloading(true);
      if (editid) {
        const responseUpdate = await Axios.post(`${CMS_API_URL}/submission/update/${domainId}`, {
          contentTypeId: SelectedType.TypeId,
          submissionId: editid,
          // contentType: SelectedType.type === "Collection" ? 101 : 102,
          draftJson: JSON.stringify(Inputvalues),
          relationJson: JSON.stringify(RelationInputvalues),
          oldRelationJson: JSON.stringify(OldRelationInputvalues),
          mediaIdList: images,
          // singular: SelectedType.data.endpoint,
          // plural: SelectedType.data.plural
        });
        if (responseUpdate.status === 200) {
          stDataStatus(isPublish ? 3 : 2);
          toast.success('Edited Successfully');
        }
        setloading(false);
        return;
      }
      const response = await Axios.post(`${CMS_API_URL}/submission/create/${domainId}`, {
        contentTypeId: SelectedType.TypeId,
        contentType: SelectedType.type === 'Collection' ? 101 : 102,
        draftJson: JSON.stringify(Inputvalues),
        relationJson: JSON.stringify(RelationInputvalues),
        oldRelationJson: JSON.stringify(OldRelationInputvalues),
        mediaIdList: images,
        singular: SelectedType.data.endpoint,
        plural: SelectedType.data.plural || SelectedType.plural,
      });

      if (response.status === 200) {
        toast.success('Saved SuccessFully');
        seteditid(response.data.data.submissionId);
      }
      setloading(false);
    } catch (error) {
      toast.error(error.response.data.message);
      console.error('Error submitting form:', error);
      setloading(false);
    }
  };
  const handlePublish = async (e) => {
    var images = getImages(Inputvalues);
    setAnswerJson(Inputvalues);
    setInputvalues(Inputvalues);
    setDraftJson(Inputvalues);
    setPublishRelationInputvalues(RelationInputvalues);
    setUpdateRelationInputvalues(RelationInputvalues);
    setOldRelationInputvalues(RelationInputvalues);
    try {
      setpublishloading(true);
      if (editid) {
        const responseUpdate = await Axios.post(`${CMS_API_URL}/submission/update/${domainId}`, {
          contentTypeId: SelectedType.TypeId,
          submissionId: editid,
          // contentType: SelectedType.type === "Collection" ? 101 : 102,
          answerJson: JSON.stringify(Inputvalues),
          relationJson: JSON.stringify(RelationInputvalues),
          oldRelationJson: JSON.stringify(OldRelationInputvalues),
          mediaIdList: images,
          // singular: SelectedType.data.endpoint,
          // plural: SelectedType.data.plural
        });
        if (responseUpdate.status === 200) {
          toast.success('Published Successfully');
          stDataStatus(1);
          setisPublish(true);
        }
        setpublishloading(false);
        return;
      }
      const response = await Axios.post(`${CMS_API_URL}/submission/create/${domainId}`, {
        contentTypeId: SelectedType.TypeId,
        contentType: SelectedType.type === 'Collection' ? 101 : 102,
        answerJson: JSON.stringify(Inputvalues),
        relationJson: JSON.stringify(RelationInputvalues),
        oldRelationJson: JSON.stringify(OldRelationInputvalues),
        mediaIdList: images,
        singular: SelectedType.data.endpoint,
        plural: SelectedType.data.plural || SelectedType.plural,
      });
      if (response.status === 200) {
        toast.success('Saved SuccessFully');
        seteditid(response.data.data.submissionId);
        stDataStatus(1);
        setisPublish(true);
      }
      setpublishloading(false);
    } catch (error) {
      toast.error(error.response.data.message);
      console.error('Error submitting form:', error);
      setpublishloading(false);
    }
  };

  const handleUnpublish = async (status) => {
    try {

      const response = await Axios.post(`${CMS_API_URL}/submission/unpublish`, {
        submissionId: submitionId,
        domainUUID: domainId
      });
      if (response.status === 200) {
        if (status === false) {
          setDraftJson(AnswerJson);
          setRelationInputvalues(PublishRelationInputvalues);
          setOldRelationInputvalues(PublishRelationInputvalues);
          setUpdateRelationInputvalues(PublishRelationInputvalues);
          setInputvalues(AnswerJson);
        }
        stDataStatus(2);

        setAnswerJson({});
      }


    } catch (err) {
      console.error(err);

    }
  };

  const handleDiscardChanges = async () => {
    try {

      const response = await Axios.post(`${CMS_API_URL}/submission/discard`, {
        submissionId: submitionId,
        domainUUID: domainId
      });
      if (response.status === 200) {
        setDraftJson(AnswerJson);
        setRelationInputvalues(PublishRelationInputvalues);
        setOldRelationInputvalues(PublishRelationInputvalues);
        setUpdateRelationInputvalues(PublishRelationInputvalues);
        setInputvalues(AnswerJson);
        stDataStatus(1);
      }


    } catch (err) {
      console.error(err);

    }
  };

  // =====================================================================================================
  // ======================================== Status Functions ===========================================
  // =====================================================================================================

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="d-flex justify-content-end mb-3">
          {SelectedType ? (
            <ManageButton
              DataStatus={DataStatus}
              isEdited={isEdited}
              editid={editid}
              publishloading={publishloading}
              isDraft={isDraft}
              SelectTab={SelectTab}
              setSelectTab={setSelectTab}
              isPublish={isPublish}
              handlePublish={handlePublish}
              handleUnpublish={handleUnpublish}
              handleDiscardChanges={handleDiscardChanges}
              loading={loading}
            />
          ) : (
            <div className="d-flex gap-1">
              <ButtonC
                text="Create New Entry"
                size="lg"
                disabled={!CollectionType}
                click={() => {
                  seteditid(null);
                  setisPublish(false);
                  stDataStatus(2)
                  handleCollectiondata(CollectionType);
                }}
              />
              <div>
                {Donloadloading ? (
                  <ButtonC
                    size="lg"
                    text="Export data"
                    click={handleDownload}
                    color="Secondary"
                    loading={Donloadloading}
                  >
                    <Spinner color="#e6e6e6" size="sm" className="mx-1" />
                  </ButtonC>
                ) : (
                  <ButtonC
                    size="lg"
                    text="Export data"
                    disabled={!CollectionType}
                    click={handleDownload}
                    type="submit"
                    color="Secondary"
                    loading={Donloadloading}
                  />
                )}
              </div>
              <ConfigButton headerData={header} setSelectedFields={setheader}
                disabled={!CollectionType}
              />
            </div>
          )}
        </div>
        <Row>
          <Col xl={2} style={{ width: '20%' }} className="pe-0">
            <FormC title="Content Manager" className="ContentBuilder " tsize="sm">
              <div className="cms-height">
                {/* <InputC disabled={!!OverlaySelectedType} type="Searchbar" className="px-4 pt-4" placeholder="Search..." /> */}
                <div className="">
                  <div
                    className="d-flex align-items-center ContentCard gap-3 px-4"
                    onClick={() => handlecollapse('collection')}
                  >
                    <div style={{ rotate: Collapsediv['collection'] ? '270deg' : '0deg' }}>
                      {' '}
                      {SVG.arrow}{' '}
                    </div>{' '}
                    <div className="titlestyle">Collection Types</div>
                  </div>
                  <Collapse isOpen={!Collapsediv['collection']}>
                    {props.cms.collections.length > 0 ? (
                      props.cms.collections.map((item, index) => {
                        return (
                          <div
                            className={`ContentCard ps-5 pe-5 ${CollectionType?.id === item.id && 'SelectedCard justify-content-between d-flex '}`}
                            onClick={() =>
                              navigate(`/CMS/contentmanager/${domainId}/collection/${item.plural}/`)
                            }
                            key={index}
                          >
                            <span>{item.data.label}</span>
                          </div>
                        );
                      })
                    ) : (
                      <div className="ContentCard addButton p-2">
                        <span>No Data</span>
                      </div>
                    )}
                  </Collapse>
                </div>

                <div className="">
                  <div
                    className="d-flex align-items-center ContentCard gap-3 px-4"
                    onClick={() => handlecollapse('Single')}
                  >
                    <div style={{ rotate: Collapsediv['Single'] ? '270deg' : '0deg' }}>
                      {' '}
                      {SVG.arrow}{' '}
                    </div>{' '}
                    <div className="titlestyle">Single Types</div>
                  </div>
                  <Collapse isOpen={!Collapsediv['Single']}>
                    {props.cms.singles.length > 0 ? (
                      props.cms.singles.map((item, index) => {
                        return (
                          <div
                            className={`ContentCard ps-5 pe-5 ${SelectedType && SelectedType?.id === item.id && 'SelectedCard justify-content-between d-flex '}`}
                            onClick={() =>
                              navigate(`/CMS/contentmanager/${domainId}/single/${item.data.plural}`)
                            }
                            key={index}
                          >
                            <span>{item.data.label}</span>
                          </div>
                        );
                      })
                    ) : (
                      <div className="ContentCard addButton p-2">
                        <span>No Data</span>
                      </div>
                    )}
                  </Collapse>
                </div>
              </div>
            </FormC>
          </Col>

          {!istable && (submitionId !== undefined || submitionId !== null) && (
            <>
              <Col xl={SelectedType ? 7 : 9} className="pe-0">
                <FormC
                  className="h-100"
                  title={SelectedType?.data?.label}
                  discription={`API ID : ${SelectedType?.plural}`}
                  rightchild={
                    !istable && (submitionId !== undefined || submitionId !== null) ? (
                      SelectedType ? (
                        <DraftLogic
                          isDraft={isDraft}
                          isEdited={isEdited}
                          SelectTab={SelectTab}
                          setSelectTab={setSelectTab}
                          DataStatus={DataStatus}
                        />
                      ) : (
                        <></>
                      )
                    ) : (
                      <></>
                    )
                  }
                >
                  {SelectedType ? (
                    <>
                      <div className="d-flex justify-content-between">
                        <div>
                          <h4 className="main-title">{SelectedType?.data?.label}</h4>
                          {/* <span className="Title-small">Build the data architecture of your content</span> */}
                        </div>
                      </div>
                      <div className=" h-100">
                        {SelectedType.keys.length > 0 ? (
                          <>
                            <div className="row">
                              {SelectedType.keys.map((item, index) => {
                                var resultArray = [];
                                if (item.type === 'Component' && item.repeatable) {
                                  const data = Components.filter(
                                    (datakey) => item.Component === datakey.id,
                                  );
                                  resultArray = Array.from(
                                    { length: Inputvalues?.[item.name]?.length },
                                    (_, index) => index,
                                  );
                                }
                                if (item.type === 'JSON') {
                                  var sample = Inputvalues?.[item.name];
                                }
                                return item.type === 'dropzone' ? (
                                  <div
                                    className="col-lg-6 col-md-6 col-sm-12 mt-3 dropdownclass"
                                    key={index}
                                  >
                                    <InputC
                                      disabled={!!OverlaySelectedType || !isDraft}
                                      label={item.name}
                                    />
                                    <div className="Dropzone">
                                      {Inputvalues?.[item.name] &&
                                        Inputvalues?.[item?.name].length > 0 ? (
                                        // <div className=''>
                                        //     {/* <img src={Inputvalues?.[item.name][0].src} /> */}
                                        //     <p>
                                        //         Drag and drop file here or <span className="color-underline">Choose file</span>
                                        //     </p>
                                        //     <p>
                                        //         <span> {Inputvalues?.[item.name].length} </span> Media File Selected <span className="color-underline"></span>
                                        //     </p>
                                        //     {/* <span>( {Inputvalues?.[item.name].length} )</span> */}
                                        // </div>
                                        <CarousalC
                                          disabled={!!OverlaySelectedType || !isDraft}
                                          click={togglemodel}
                                          item={item}
                                          items={Inputvalues?.[item?.name].map(formatData)}
                                        />
                                      ) : (
                                        <div
                                          style={{
                                            opacity: !!OverlaySelectedType || !isDraft ? 0.5 : 1,
                                          }}
                                          onClick={() => {
                                            if (!!OverlaySelectedType || !isDraft) {
                                              return;
                                            }
                                            togglemodel(item);
                                          }}
                                        >
                                          <div className="d-flex justify-content-center">
                                            {SVG.Dropzone}
                                          </div>
                                          <div className="d-flex justify-content-center dropzone-font-size">
                                            <p>
                                              Drag and drop file here or{' '}
                                              <span className="color-underline">Choose file</span>
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : item.type === 'Component' ? (
                                  <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                                    {resultArray.length > 0 && item.repeatable ? (
                                      <>
                                        {resultArray.map((data, index) =>
                                          getArrayComponrnt(item, index),
                                        )}
                                        {/* {getArrayComponrnt(item, 1, true)} */}
                                      </>
                                    ) : item.repeatable ? (
                                      getArrayComponrnt(item, 0, true)
                                    ) : (
                                      getComponrnt(item)
                                    )}
                                  </div>
                                ) : item.type === 'JSON' ? (
                                  <div className="col-lg-12 col-md-12 col-sm-12 mt-3" key={index}>
                                    <InputC
                                      disabled={!!OverlaySelectedType || !isDraft}
                                      isClearable={true}
                                      label={item.name}
                                      name={item.name}
                                      type={'json'}
                                      placeholder={item.name}
                                      inputvalue={sample}
                                      required={item.required}
                                      size="sm"
                                      // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                      change={(e) => {
                                        if (e.error || e.error.reason) {
                                          toast.error(`Json in ${item.name} field is invalid`);
                                          return;
                                        }
                                        handleJSONInput(item.name, e.json);
                                      }}
                                    />
                                  </div>
                                ) : item.type === 'number' ? (
                                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                    <InputC
                                      disabled={!!OverlaySelectedType || !isDraft}
                                      isClearable={true}
                                      label={item.name}
                                      name={item.name}
                                      type={item.type === 'UUID' ? 'text' : item.type}
                                      placeholder={item.name}
                                      inputvalue={
                                        item.type === 'select'
                                          ? Inputvalues?.[item.name]?.value
                                          : item.type === 'togglemode'
                                            ? Inputvalues?.[item.name]
                                            : Inputvalues?.[item.name]
                                      }
                                      required={item.required}
                                      size="sm"
                                      // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                      change={(e) => {

                                        e = handleValidation(item.name, e)


                                        handleInputChange(
                                          item.name,
                                          e.target.value,
                                          item.format,
                                          item,
                                        )
                                      }
                                      }
                                    />
                                  </div>
                                ) : item.type === 'text' ? (
                                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                    <InputC
                                      disabled={!!OverlaySelectedType || !isDraft}
                                      isClearable={true}
                                      label={item.name}
                                      name={item.name}
                                      rows={5}
                                      type={item.Type === 2 ? 'TextArea' : 'text'}
                                      placeholder={item.name}
                                      pattern={item.RegEx || undefined}
                                      inputvalue={Inputvalues?.[item.name] || ''}
                                      required={item.required}
                                      size="sm"
                                      error={errorMessage[item.name]}
                                      // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                      change={(e) =>
                                        handleTextInput(item.name, e.target.value, item.Type, item)
                                      }
                                    />
                                  </div>
                                ) : item.type === 'UUID' ? (
                                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                    <InputC
                                      disabled={!!OverlaySelectedType || !isDraft}
                                      isClearable={true}
                                      label={item.name}
                                      name={item.name}
                                      type={item.type === 'UUID' ? 'text' : item.type}
                                      placeholder={item.name}
                                      error={errorMessage[item.name]}
                                      inputvalue={
                                        item.type === 'select'
                                          ? Inputvalues?.[item.name]?.value
                                          : item.type === 'togglemode'
                                            ? Inputvalues?.[item.name]
                                            : Inputvalues?.[item.name] || ""
                                      }
                                      required={item.required}
                                      size="sm"
                                      // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                      change={(e) => {
                                        e = handleValidation(item, e);
                                        handleUUIDInput(item.name, e.target.value);
                                      }}
                                    />
                                  </div>
                                ) : item.type === 'date' ? (
                                  <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                    <InputC
                                      disabled={!!OverlaySelectedType || !isDraft}
                                      isClearable={true}
                                      label={item.name}
                                      name={item.name}
                                      type={
                                        item.format === 'Time'
                                          ? 'time'
                                          : item.format === 'DateTime'
                                            ? 'datetime-local'
                                            : item.type
                                      }
                                      placeholder={item.name}
                                      isEdit={item?.isMulti}
                                      isMulti={item?.isMulti}
                                      error={errorMessage[item.name]}
                                      inputvalue={
                                        item.type === 'select'
                                          ? Inputvalues?.[item.name]?.value
                                          : item.type === 'togglemode'
                                            ? Inputvalues?.[item.name]
                                            : Inputvalues?.[item.name] || ""
                                      }
                                      required={item.required}
                                      size="sm"
                                      // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                      change={(e) => handleInput(item.name, e.target.value)}
                                    />
                                  </div>
                                ) : item.type === 'relation' ? (
                                  // <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
                                  //     <InputC
                                  //         isClearable={true}
                                  //         label={item.name}
                                  //         name={item.name}
                                  //         type="Asyncselect"
                                  //         isEdit={false}
                                  //         placeholder={item.name}
                                  //         loadOptions={(e) => loadRelationOptions(e, item)}
                                  //         inputvalue={item.type === "select" ? Inputvalues?.[item.name]?.value : item.type === "togglemode" ? Inputvalues?.[item.name] : Inputvalues?.[item.name]}
                                  //         required={item.required}
                                  //         size="sm"
                                  //         // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                  //         change={(e) => item.type === "select" || item.type === "editor" ? handleInput(item.name, e) : item.type === "togglemode" ? handleInput(item.name, !Inputvalues?.[item.name]) : handleInput(item.name, e.target.value)}
                                  //     />
                                  // </div>
                                  <></>
                                ) : (
                                  <div
                                    className={` ${item.type === 'editor' ? 'col-lg-12 col-md-12 col-sm-12 mt-3' : 'col-lg-6 col-md-6 col-sm-12 mt-3'}`}
                                    key={index}
                                  >
                                    <InputC
                                      disabled={!!OverlaySelectedType || !isDraft}
                                      isClearable={true}
                                      label={item.name}
                                      name={item.name}
                                      type={
                                        item.type === 'UUID'
                                          ? 'text'
                                          : item.type === 'editor'
                                            ? 'CMSeditor'
                                            : item.type === 'text'
                                              ? item.Type === 2 ? 'TextArea' : item.type
                                              : item.type
                                      }
                                      isEdit={item?.isMulti}
                                      isMulti={item?.isMulti}
                                      placeholder={item.name}
                                      options={item?.predefine ? PredefinedValues[item.predefineoption] : item.options}
                                      error={errorMessage[item.name]}
                                      inputvalue={
                                        item.type === 'select'
                                          ? item?.isMulti ? Inputvalues?.[item.name] : Inputvalues?.[item.name]?.value
                                          : item.type === 'togglemode'
                                            ? Inputvalues?.[item.name]
                                            : Inputvalues?.[item.name] || ""
                                      }
                                      required={item.required}
                                      size="sm"
                                      // KeyPress={(e) => handleKeyPress(e, item.format, item.name)}
                                      change={(e) => {
                                        let value = handleValidation(item, e);

                                        if (item.type === 'select' || item.type === 'editor') {
                                          handleInput(item.name, e, item);
                                        } else if (item.type === 'togglemode') {
                                          handleInput(item.name, !Inputvalues?.[item.name], item);
                                        } else {
                                          handleInput(item.name, value, item);
                                        }
                                      }}
                                    />
                                  </div>
                                );
                              })}
                            </div>

                            <RelationInputComponent SelectedType={SelectedType} OverlaySelectedType={OverlaySelectedType} isDraft={isDraft} loadRelationOptions={loadRelationOptions} UpdateRelationInputvalues={UpdateRelationInputvalues} handleRelationInput={handleRelationInput} />
                          </>
                        ) : (
                          <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="w-25">
                              <Nodatacomponent text="No Structure is Found" />
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <div className="h-100 d-flex justify-content-center align-items-center">
                      <div className="w-25">
                        {firstloading ? (
                          <SpinnerLoader />
                        ) : (
                          <Nodatacomponent text="Select a type" />
                        )}
                      </div>
                    </div>
                  )}
                </FormC>
              </Col>
              {SelectedType && (
                <Col>
                  <FormC title="General Details">
                    <div className="">
                      <div className="d-flex justify-content-between flex-row  py-2">
                        <span className="title-general">Created On</span>
                        <span>{Creationdata.createdon || ''}</span>
                      </div>
                      <div className="d-flex justify-content-between flex-row py-2">
                        <span className="title-general">Created By</span>
                        <span>{Creationdata.createdby}</span>
                      </div>
                      <div className="d-flex justify-content-between flex-row py-2">
                        <span className="title-general">Last Updated On</span>
                        <span>{Creationdata.updatedon}</span>
                      </div>
                      <div className="d-flex justify-content-between flex-row py-2">
                        <span className="title-general">Last Updated By</span>
                        <span>{Creationdata.updatedby}</span>
                      </div>
                    </div>
                  </FormC>
                  <div
                    className={`${StatusClasses[DataStatus].div} mt-2 published-div`}
                    style={{ background: StatusClasses[DataStatus].bacground }}
                  >
                    <ul className="custom-bullets">
                      <li style={{ color: StatusClasses[DataStatus].text, listStyleType: 'disc' }}>
                        <span style={{ color: 'black' }}>
                          Editing{' '}
                          <span
                            className="published"
                            style={{ color: StatusClasses[DataStatus].text }}
                          >
                            {StatusValues[DataStatus]}
                          </span>{' '}
                          version
                        </span>
                      </li>
                    </ul>
                  </div>
                </Col>
              )}
            </>
          )}

          {istable && (submitionId === undefined || submitionId === null) && (
            <Col>
              <FormC className="h-100" title={CollectionType?.data?.label}>
                <FiltersCM
                  setFilterdata={setFilterdata}
                  Filterdata={Filterdata}
                  headerData={header}
                />
                {/* ========================================== COLEECTION TABLE ==================================================== */}
                {loadingdata ? (
                  <SpinnerLoader />
                ) : (
                  <>
                    {CollectionType ? (
                      <div>


                        <TableC
                          Theads={headerData}
                          isHover={true}
                          tablebutton={tablebutton}
                          data={Tabledata}
                          onRowClick={RowClick}
                          footer={parseInt(Pagination?.totalPages) > 1}
                          footerdata={{
                            totalpages: Pagination?.totalPages,
                            currentpage: currentpage,
                            pagechange: (e) => {
                              const params = Object.fromEntries(searchParams);

                              if (e.pageLimit !== pagesize) {
                                setpagesize(e.pageLimit);
                                params.pageSize = e.pageLimit;
                              }
                              params.page = e.currentPage;

                              setcurrentpage(e.currentPage);
                              setSearchParams(params);

                            },
                            pageLimit: pagesize,
                            changePageNo: (e) => { },
                            // searchInput: string
                          }}
                        />
                      </div>
                    ) : (
                      <div className="h-100 d-flex justify-content-center align-items-center">
                        <div className="w-25">
                          {firstloading ? (
                            <SpinnerLoader />
                          ) : (
                            <Nodatacomponent text="Select a type" />
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}

                {/* ========================================== COLEECTION TABLE ==================================================== */}
              </FormC>
            </Col>
          )}
        </Row>
      </form>
      <SideOverlay
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        Inputvalues={Inputvalues}
        SelectedType={OverlaySelectedType}
        setOverlaySelectedType={setOverlaySelectedType}
        UpdateRelationInputvalues={UpdateRelationInputvalues}
        getArrayComponrnt={getArrayComponrnt}
        getComponrnt={getComponrnt}
        togglemodel={togglemodel}
        loadRelationOptions={loadRelationOptions}
        Components={Components}
      />
      {DropZoneModel(
        openmodel,
        togglemodel,
        props.cms.media,
        handleInput,
        Componentdata,
        domainId,
        props.cms.mediapagination,
        props.GetMedia,
      )}
      {DropZoneModel(
        openComponentmodel,
        toggleComponentmodel,
        props.cms.media,
        handleComponent,
        Componentdata,
        domainId,
        props.cms.mediapagination,
        props.GetMedia,
      )}
      {DropZoneModel(
        openComponentArraymodel,
        toggleArrayComponentmodel,
        props.cms.media,
        handleArrayComponent,
        Componentdata,
        domainId,
        props.cms.mediapagination,
        props.GetMedia,
      )}
      {DropZoneModel(
        openNestedComponentArraymodel,
        toggleNestedArrayComponentmodel,
        props.cms.media,
        handleNestedArrayComponent,
        Componentdata,
        domainId,
        props.cms.mediapagination,
        props.GetMedia,
      )}

      {DropZoneModel(
        openNestedComponentmodel,
        toggleNestedComponentmodel,
        props.cms.media,
        handleNestedComponent,
        Componentdata,
        domainId,
        props.cms.mediapagination,
        props.GetMedia,
      )}

      {DropZoneModel(
        openNestedNestedComponentArraymodel,
        toggleNestedNestedArrayComponentmodel,
        props.cms.media,
        handleNestedArrayComponent,
        Componentdata,
        domainId,
        props.cms.mediapagination,
        props.GetMedia,
      )}
    </>
  );
};

const mapStateToProps = ({ cms }, props) => ({
  cms,
});

export default connect(mapStateToProps, {
  changeCollectionsdata,
  changeSinglesdata,
  changeComponentsdata,
  GetMedia,
})(ContentManager);




const RelationInputComponent = ({
  SelectedType,
  OverlaySelectedType,
  isDraft,
  loadRelationOptions,
  UpdateRelationInputvalues,
  handleRelationInput
}) => {
  const [localValues, setLocalValues] = useState(UpdateRelationInputvalues);
  const [optionsMap, setOptionsMap] = useState({}); // store options for each input

  useEffect(() => {
    setLocalValues({ ...UpdateRelationInputvalues });
  }, [UpdateRelationInputvalues]);

  return (
    <div className="row">
      {SelectedType?.relationShipList?.map((item, index) => {
        const isMulti = RelationSelect(
          item.Component,
          item.relationShipType,
          item.mainId
        );

        const selectedIds = Array.isArray(localValues[item.name]?.ids)
          ? localValues[item.name]?.ids
          : [localValues[item.name]?.ids].filter(Boolean);

        const selectedOptions = selectedIds
          .map((id) =>
            optionsMap[item.name]?.find((opt) => opt.value === id.value)
          )
          .filter(Boolean);

        return (
          <div className="col-lg-6 col-md-6 col-sm-12 mt-3" key={index}>
            <InputC
              disabled={!!OverlaySelectedType || !isDraft}
              isClearable={true}
              label={`${item.name}`}
              name={item.name}
              type="Asyncselect"
              isEdit={!isMulti}
              placeholder={item.name}
              loadOptions={(inputValue, callback) => {
                loadRelationOptions(inputValue, item, (options) => {
                  setOptionsMap((prev) => ({
                    ...prev,
                    [item.name]: options
                  }));
                  callback(options);
                });
              }}
              inputvalue={selectedOptions}
              required={item.required}
              size="sm"
              change={(e) => handleRelationInput(item.name, e, item)}
              isCustum={true}
            />
          </div>
        );
      })}
    </div>
  );
};
